/* Threadmates Industrial — minimal theme JS (vanilla, no deps)
   Includes: drawer · accordion · variant pickers · gallery
            · animated number counters · scroll-reveal · stagger
            · lazy image loading · prefers-reduced-motion respect
*/
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Mobile menu drawer ---------- */
  var menuBtn = document.querySelector('[data-menu-open]');
  var menuClose = document.querySelector('[data-menu-close]');
  var drawer = document.querySelector('[data-menu-drawer]');
  if (menuBtn && drawer) {
    menuBtn.addEventListener('click', function () {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (menuClose && drawer) {
    menuClose.addEventListener('click', function () {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }
  if (drawer) {
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }
  // Close drawer with Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq__item');
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (item) item.classList.toggle('is-open', !expanded);
    });
  });

  /* ---------- Product variant pickers ---------- */
  document.querySelectorAll('[data-swatches]').forEach(function (group) {
    var label = group.parentElement.querySelector('.selected');
    group.querySelectorAll('.swatch').forEach(function (s) {
      s.addEventListener('click', function () {
        group.querySelectorAll('.swatch').forEach(function (x) { x.classList.remove('is-active'); });
        s.classList.add('is-active');
        if (label) label.textContent = s.dataset.name || '';
      });
    });
  });
  document.querySelectorAll('[data-sizes]').forEach(function (group) {
    var label = group.parentElement.querySelector('.selected');
    group.querySelectorAll('.size').forEach(function (s) {
      if (s.classList.contains('is-out')) return;
      s.addEventListener('click', function () {
        group.querySelectorAll('.size').forEach(function (x) { x.classList.remove('is-active'); });
        s.classList.add('is-active');
        if (label) label.textContent = s.dataset.name || s.textContent;
      });
    });
  });
  document.querySelectorAll('[data-quantity]').forEach(function (group) {
    var input = group.querySelector('input');
    var minus = group.querySelector('[data-qty-minus]');
    var plus = group.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, parseInt(input.value || 1, 10) - 1); });
    if (plus)  plus.addEventListener('click', function () { input.value = parseInt(input.value || 1, 10) + 1; });
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.src || (thumb.querySelector('img') && thumb.querySelector('img').src);
        if (main && src) main.src = src;
      });
    });
  });

  /* ---------- Animated counter for stats numbers ----------
     Parses leading number from text (handles "1.2M+", "180+", "2–4",
     "4.9/5", "$15", commas, decimals), animates from 0 → target on
     viewport entry, then snaps to the original string.
  */
  function parseTarget(text) {
    var m = String(text).match(/([^0-9\-]*)([\d.,]+)(.*)/);
    if (!m) return null;
    var prefix = m[1] || '';
    var rawNum = m[2].replace(/,/g, '');
    var suffix = m[3] || '';
    var num = parseFloat(rawNum);
    if (isNaN(num)) return null;
    var decimals = (rawNum.split('.')[1] || '').length;
    return { prefix: prefix, num: num, decimals: decimals, suffix: suffix, original: text };
  }
  function animateNumber(el) {
    var original = el.dataset.count || el.textContent.trim();
    el.dataset.count = original;
    if (prefersReducedMotion) { el.textContent = original; return; }
    var parsed = parseTarget(original);
    if (!parsed) return;
    var start = performance.now();
    var duration = 1500;
    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var current = parsed.num * eased;
      var rendered = parsed.decimals > 0
        ? current.toFixed(parsed.decimals)
        : Math.round(current).toLocaleString();
      el.textContent = parsed.prefix + rendered + parsed.suffix;
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = original;
    }
    requestAnimationFrame(tick);
  }

  /* ---------- Scroll-reveal + stagger ----------
     Adds .is-visible to opted-in elements when they enter the viewport.
     Container with [data-stagger] also reveals its direct children with
     a small per-item delay set via inline style on the way in.
  */
  if ('IntersectionObserver' in window) {
    var statObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animateNumber(entry.target);
        statObserver.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.stat__num, [data-counter]').forEach(function (el) {
      statObserver.observe(el);
    });

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        // If it's a stagger container, cascade the reveal across children
        if (e.target.hasAttribute('data-stagger')) {
          var kids = e.target.children;
          for (var i = 0; i < kids.length; i++) {
            (function (kid, idx) {
              kid.style.transitionDelay = (idx * 70) + 'ms';
              kid.classList.add('is-revealed');
            })(kids[i], i);
          }
        }
        revealObserver.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-reveal], [data-stagger]').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    // No IO support — just show everything
    document.querySelectorAll('[data-reveal], [data-stagger]').forEach(function (el) {
      el.classList.add('is-visible');
      Array.prototype.forEach.call(el.children || [], function (kid) {
        kid.classList.add('is-revealed');
      });
    });
    document.querySelectorAll('.stat__num, [data-counter]').forEach(function (el) {
      el.textContent = (el.dataset.count || el.textContent || '').toString();
    });
  }

  /* ---------- Lazy load images that lack the loading attribute ---------- */
  document.querySelectorAll('img:not([loading])').forEach(function (img) {
    img.setAttribute('loading', 'lazy');
    img.setAttribute('decoding', 'async');
  });
})();
